module.exports = __webpack_public_path__ + "img/upload-bg.b0e3d6fb.png";